module.exports = __webpack_public_path__ + "public/Icons/money.svg?f87c3e4b";